function getSessionId() {
  const key = "__APP_SESSION_ID__";
  if (!window[key]) {
    window[key] = crypto.randomUUID();
  }
  return window[key];
}

function createBaseItem(partial) {
  return {
    type: partial.type || "UnityError",
    message: partial.message || "Unknown Unity error",
    stack: partial.stack || "",
    extra: partial.extra || null,
    platform: partial.platform,
    udid: partial.udid,
    host: window.location.host,
    userAgent: navigator.userAgent,
    timeUtc: new Date().toISOString(),
  };
}

function normalizeMessage(message) {
  return String(message)
    .replace(/\b0x[0-9a-fA-F]+\b/g, "0x*")
    .replace(/\b\d+\b/g, "*")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, 500);
}

function normalizeStack(stack) {
  return String(stack)
    .split("\n")
    .slice(0, 6)
    .join("\n")
    .replace(/\b0x[0-9a-fA-F]+\b/g, "0x*")
    .replace(/:\d+:\d+/g, ":*:*")
    .replace(/\b\d+\b/g, "*")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, 800);
}

function buildFingerprint(item) {
  const msg = normalizeMessage(item.message);
  const stack = normalizeStack(item.stack || "");
  return [item.type, msg, stack].join("|");
}

async function sendToYourServer(payload) {
  var content = JSON.stringify(payload)
  console.log("send to your server: " + content)
  await fetch("https://log.cashrush.cc/err/log", {
    method: "POST",
    headers: {
      "Content-Type": "text/plain",
    },
    body: content,
    keepalive: true,
  });
}

function createClientErrorReporter() {
  const bucket = new Map();
  let flushTimer = null;

  const dedupeWindowMs = 10000;
  const flushIntervalMs = 5000;
  const maxItemsBeforeFlush = 30;

  function scheduleFlush() {
    if (flushTimer != null) return;

    flushTimer = window.setTimeout(() => {
      flushTimer = null;
      flush();
    }, flushIntervalMs);
  }

  async function flush() {
    if (bucket.size === 0) return;

    const payload = {
      items: Array.from(bucket.values()).map((v) => ({
        count: v.count,
        firstSeenAt: new Date(v.firstSeenAt).toISOString(),
        lastSeenAt: new Date(v.lastSeenAt).toISOString(),
        type: v.item.type,
        message: v.item.message,
        stack: v.item.stack,
        udid: v.item.udid,
        host: v.item.host,
        platform: localStorage.getItem("platform"),
      })),
    };

    bucket.clear();

    try {
      await sendToYourServer(payload);
    } catch (e) {
      console.error("[clientErrorReporter] upload failed", e, payload);
    }
  }

  function capture(partial) {
    const item = createBaseItem(partial);
    const fingerprint = buildFingerprint(item);
    const now = Date.now();

    const existing = bucket.get(fingerprint);

    if (existing) {
      if (now - existing.lastSeenAt <= dedupeWindowMs) {
        existing.count += 1;
        existing.lastSeenAt = now;
        return;
      }

      existing.count += 1;
      existing.lastSeenAt = now;
      existing.item = item;
    } else {
      bucket.set(fingerprint, {
        count: 1,
        firstSeenAt: now,
        lastSeenAt: now,
        item,
      });
    }

    if (bucket.size >= maxItemsBeforeFlush) {
      flush();
    } else {
      scheduleFlush();
    }
  }

  return {
    capture,
    flush,
  };
}

export const clientErrorReporter = createClientErrorReporter();